var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 52H42V49.4C42 47.97 40.8187 46.8 39.375 46.8H2.625C1.18125 46.8 0 47.97 0 49.4V52Z",
    fill: "#BDCCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.95 14.82L22.575 0.519998C21.6563 -0.260002 20.3438 -0.260002 19.2938 0.519998L0.918789 14.82C3.90969e-05 15.47 -0.262461 16.64 0.131289 17.68C0.525039 18.85 1.44379 19.5 2.62504 19.5H39.375C40.5563 19.5 41.475 18.85 41.8688 17.68C42.2625 16.64 41.8688 15.47 40.95 14.82ZM10.2375 14.3L21 5.85L31.7625 14.3H10.2375Z",
    fill: "#BDCCD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 22.1C7.74375 22.1 6.5625 23.27 6.5625 24.7V44.2H11.8125V24.7C11.8125 23.27 10.6312 22.1 9.1875 22.1Z",
    fill: "#006BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.1C19.5562 22.1 18.375 23.27 18.375 24.7V44.2H23.625V24.7C23.625 23.27 22.4437 22.1 21 22.1Z",
    fill: "#0AE8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 22.1C31.3687 22.1 30.1875 23.27 30.1875 24.7V44.2H35.4375V24.7C35.4375 23.27 34.2562 22.1 32.8125 22.1Z",
    fill: "#006BFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.2c1d6fb1e1a011b39197157d6d3e4932.svg";
export { ForwardRef as ReactComponent };